import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SimpleSearch } from '../../../../../reduxToolkit/Search/SearchApi';
import CustomTh from "../../../../../components/table/CustomTh";
import CustomTd from "../../../../../components/table/CustomTd";
import {errorMsg, getValueByKey} from "../../../../../Apis/functions";
import { DEVICE_TYPE } from "../Model/Models";
import TableFunction from "../../../../../components/table/TableFunction";
import { permissionObj } from "../../../../../Helpers/permission";
import { SEARCH_MODEL } from "../../../../../components/table/Model/TableModel";
import { TABLES } from "../../../../../Apis/Tables";
import { INPUT_NUMBER_DATA } from "../../Inputs/Model/Models";
import {DeleteItemsApi} from "../../../../../reduxToolkit/Commons/CommonsApi";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description
 * Hook-based component to display and manage the SIO table.
 * Supports fetching data, pagination, selection, and deletion of SIO records.
 * Integrates Redux for state management and permissions.
 */

const MainSiosTableApp = ({ selectedList, setSelectedList }) => {
    const dispatch = useDispatch();
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);

    // Local states
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [search, setSearch] = useState(false);
    const [searchElement, setSearchElement] = useState('');
    const [bodyForExport, setBodyForExport] = useState('');
    const [results, setResults] = useState([]);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [modified, setModified] = useState(false);
    const [tableId, setTableId] = useState("tbl_st_table");
    const [searchId, setSearchId] = useState("tbl_st_search_id");

    const deletePermission = (DEV || permission?.includes(permissionObj?.WEB_HID_DELETE));
    const leftPosition = deletePermission ? 50 : 0;
    const option = TABLES.HID_SIO;

    /**
     * Builds the table headers dynamically.
     */
    const getThead = () => {
        return [
            <CustomTh tableId={tableId} classes="first_head" fixedXY={true} left={leftPosition}>{t('name')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('controller')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('input_number')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('device_type')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('port_number')}</CustomTh>
        ];
    };

    /**
     * Builds the table body from API results.
     */
    const getTbody = () => {
        if (!results || results?.content?.length === 0) return { body: [], data: [] };

        const body = results?.content?.map((item) => {
            return (
                <>
                    <CustomTd tableId={tableId} classes={"first-column"} fixed={true}
                              left={leftPosition}>{item?.name}</CustomTd>
                    <CustomTd tableId={tableId}>{item?.hidName}</CustomTd>
                    <CustomTd tableId={tableId}>{getValueByKey(item?.number, 'name', INPUT_NUMBER_DATA)}</CustomTd>
                    <CustomTd tableId={tableId}>{getValueByKey(item?.deviceType, 'name', DEVICE_TYPE)}</CustomTd>
                    <CustomTd tableId={tableId}>{item?.portNumber}</CustomTd>
                </>
            );
        });

        return { body, data: results?.content };
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({ page, size: rowsPerPage, model: option, key:searchElement });
        setBodyForExport(body);
        dispatch(SimpleSearch({ body })).then(
            ({ payload: { data: { data, success } } }) => {
                if (success === true) {
                    setResults(data);
                }
            },
        );
    }

    // Table hooks and handlers
    const { t, thead, tbody, handleCheckboxChange, handleDeleteAll, pagination, page, rowsPerPage } = TableFunction({
        selectedList,
        setSelectedList,
        data: results,
        getThead,
        getTbody,
        labelRowsPerPage: 'sios_per_page',
        setIsAllChecked,

        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    /**
     * Deletes selected SIO records via API.
     */
    const deleteSelectedSio = () => {
        const body = selectedList;
        if (body.length > 0) {
            dispatch(DeleteItemsApi({ tableName: TABLES.HID_SIO, body })).then(
                ({ payload: { data: { success, code } } }) => {
                    if (success === true) {
                        setSelectedList([]);
                        setIsAllChecked(false);
                        setModified(true);
                    }else errorMsg(code);
                },
            );
        }
    };

    // Expose states and handlers to parent
    return {
        t,
        DEV,
        permission,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        page,
        rowsPerPage,
        setResults,
        option,
        searchElement,
        setSearchElement,
        setSearch,
        setBodyForExport,
        setSimpleSearch,
        deletePermission,
        isAllChecked,
        setModified,
        handleCheckboxChange,
        handleDeleteAll,
        deleteSelectedSio
    };
};

export default MainSiosTableApp;
